let apiUrl = process.env.VUE_APP_API_CC;
import { decrypt } from "../vendor/crypto";

class CC {
  static getInfos(data, refresh) {
    if (data.eventId) {
      data.eventId = data.eventId.map(id =>
        /^e[0-9]{9}$/.test(id) ? id : decrypt(id)
      );
    }
    if (data.sessionId) {
      data.sessionId = data.sessionId.map(id =>
        /^s[0-9]{9}$/.test(id) ? id : decrypt(id)
      );
    }
    let params = {};
    for (const key in data) {
      params[key] = data[key].toString();
    }
    return axios
      .get(
        `${apiUrl}/get?${new URLSearchParams(params).toString()}&${
          refresh ? `reload=false` : ""
        }`
      )
      .then(res_data => [res_data, undefined])
      .catch(error => Promise.resolve([undefined, error]));
  }
}

export default CC;
